import React, { useEffect, useState } from 'react'
//components
import { Button } from "../../../components/ui/buttons/Button"
import Label from '../../../components/ui/labels/Label'
import { APIMessage } from '../../../components/ui/messages/APIMessage';
import { SelectContainer } from '../../../components/ui/layout/SelectContainer'
import Select from "react-select"
//hooks
import useJobOptions from "../../../hooks/useJobOptions";
import { useLoading } from '../../../contexts/LoadingContext';
import useUserOptions  from "../../../hooks/useUserOptions"
//api
import { assignJobToUserAPI, unassignJobFromUserAPI } from "../../../services/jobPermissionsAPI"
import { useError } from '../../../contexts/ErrorContext'
import { useSuccess } from '../../../contexts/SuccessContext';

/**
 * Displays users assigned to a job and allows user to add/remove users
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - Admin Dashboard
 */
export const JobAccess = () => {
    const [selectedJob, setSelectedJob] = useState("")
    const [usersAssigned, setUsersAssigned] = useState(null)
    const [usersAssignedOriginal, setUsersAssignedOriginal] = useState(null)

    const {jobNameOptions} = useJobOptions();
    const {showLoading, hideLoading} = useLoading()
    const { userNameOptions, userNameOptionsJob, fetchAllUsers, fetchUsersForJob} = useUserOptions()
    const {showError} = useError()
    const {timeoutSuccess} = useSuccess()

    //get users for job when selectedJob changes
    useEffect(() => {
        if(selectedJob){
            fetchAllUsers()
            fetchUsersForJob(selectedJob.value)
        }
    }, [selectedJob])

    useEffect(() => {
        setUsersAssigned(userNameOptionsJob)
        setUsersAssignedOriginal(userNameOptionsJob)
    }, [userNameOptionsJob])

    const handleSubmit = async() => {
        showLoading("Submitting...")
        
        // get ids from current and original usersAssigned
        const usersAssignedIds = usersAssigned.map(user => user.value);
        const usersAssignedOriginalIds = usersAssignedOriginal.map(user => user.value);
    
        // compare ids between current and original user groups to determine which to add and remove
        const usersToAdd = usersAssigned.filter(user => !usersAssignedOriginalIds.includes(user.value));
    
        const usersToRemove = usersAssignedOriginal.filter(user => !usersAssignedIds.includes(user.value));

        //loop through each and call api
        if(usersToAdd.length > 0){
            for(const user of usersToAdd){
                const response = await assignJobToUserAPI(selectedJob.value, user.value)
                    
                if(!response.success){
                    hideLoading()

                    showError(`Error adding user to job: ${response.message}`)
        
                    return
                }
            }
        }

        if(usersToRemove.length > 0){
            for(const user of usersToRemove){
                const response = await unassignJobFromUserAPI(selectedJob.value, user.value)
                    
                if(!response.success){
                    hideLoading()

                    showError(`Error removing user from job: ${response.message}`)
        
                    return
                }
            }
        }

        //update original state with current state
        setUsersAssignedOriginal(usersAssigned)
        
        hideLoading()
        
        timeoutSuccess("Saved")

    }

    return (
        <>
            {/* job dropdown */}
            <Label htmlFor='jobDropdown'>Select job</Label>

            <SelectContainer>
                <Select
                    value={selectedJob}
                    options={jobNameOptions}
                    name="jobDropdown"
                    onChange={(x) => setSelectedJob(x)}
                    menuPosition='fixed'
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
            </SelectContainer>


            {/* multiselect to add/remove from job */}
            { selectedJob 
            ? (
                <>
                    <Label htmlFor='jobDropdown'>Users assigned to job</Label>

                    <SelectContainer>
                        <Select
                            value={usersAssigned}
                            options={userNameOptions}
                            name="usersJobDropdown"
                            onChange={(x) => setUsersAssigned(x)}
                            menuPosition='fixed'
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            isMulti={true}
                        />
                    </SelectContainer>

                    <Button variant='success' onClick={() => handleSubmit()}>Submit</Button>

                </>

            ) : null
            }

        </>
    )
}